// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__1ap0u","modalTitleWrapper":"Modal_modalTitleWrapper__37fQw","closeIcon":"Modal_closeIcon__1-4RU","actionWrapper":"Modal_actionWrapper__1ZD1t"};